// (A) 중립 입력 API — antd 미접촉. (B) PlainInput(플레인) 에 위임.
import { forwardRef } from 'react'
import type { ChangeEvent, CSSProperties, FocusEvent, KeyboardEvent, ReactNode } from 'react'
import { PlainInput } from '../_impl/PlainInput'

/** 명령형 핸들(실측: rename/confirm 팝업이 focus·select 사용). */
export interface OmwInputRef {
  focus: () => void
  select: () => void
  blur: () => void
}

export interface OmwInputProps {
  /** native input id(→ <label htmlFor> 연결용). antd Input 파리티. */
  id?: string
  value?: string
  /** 편의: 값(string)만 전달. */
  onChange?: (value: string) => void
  /** escape hatch: name/type 등 event 속성이 필요한 소비처용. */
  onChangeEvent?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  placeholder?: string
  disabled?: boolean
  /** 검증 실패 표시(→ antd status="error"). */
  invalid?: boolean
  /** native input type. url 은 ninegqlUI url 필드용(모바일 키보드/시맨틱 유지). */
  type?: 'text' | 'password' | 'url'
  size?: 'sm' | 'md' | 'lg'
  suffix?: ReactNode
  /** 앞 아이콘. */
  prefix?: ReactNode
  /** 지우기(X) 버튼(→ antd allowClear). */
  allowClear?: boolean
  autoFocus?: boolean
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  /** Enter 키 입력(→ antd onPressEnter). */
  onPressEnter?: (e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onFocus?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  /** 검색 인풋(→ antd Input.Search). enterButton/onSearch 지정 시 활성. */
  onSearch?: (value: string) => void
  /** 검색 버튼 슬롯(→ antd Input.Search enterButton). */
  enterButton?: ReactNode
  /** 지우기(X) 클릭 콜백(→ antd onClear). */
  onClear?: () => void
  /** 여러 줄(→ antd Input.TextArea). */
  multiline?: boolean
  rows?: number
  /** multiline 자동 높이(→ antd TextArea autoSize). */
  autoSize?: boolean | { minRows?: number; maxRows?: number }
  maxLength?: number
  className?: string
  style?: CSSProperties
  'data-testid'?: string
}

export const OmwInput = forwardRef<OmwInputRef, OmwInputProps>(function OmwInput(props, ref) {
  return <PlainInput {...props} ref={ref} />
})
